import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import moment from 'moment'
import { Form, Select, Row, Col, Input, DatePicker } from 'antd'
import MainLayout from 'Hoc/MainLayout'
import Loader from 'Components/Loader'
import { StyledH1, FormItemUppercase, StyledButton, FormItemCenter } from 'Containers/EditDossier/styled'
import { fetchDepartments } from 'Actions/data-actions'
import api from 'Common/api'
import { formatDate, getYear, handleServerError } from 'Common/utils'
import { DATE_LOCALE } from 'Common/globals'

const { Option } = Select
const { RangePicker } = DatePicker

const PromoLocaliForm = Form.create({ name: 'create_promo_locali' })((props) => {
  const { form, departments, onSave, isSaving } = props
  const { getFieldDecorator } = form

  const handleSubmit = () => {
    form.validateFields((err, values) => {
      if (!err) {
        onSave(values)
      }
    })
  }

  return (
    <Form layout="vertical">
      <FormItemUppercase label="Reparto" colon={false}>
        {getFieldDecorator('department', {
          rules: [{ required: true, message: 'Scegli un reparto' }],
        })(
          <Select>
            {departments.map((department) => (
              <Option key={department.id} value={department.id}>
                {`${department.id}-${department.label}`}
              </Option>
            ))}
          </Select>,
        )}
      </FormItemUppercase>
      <FormItemUppercase label="Descrizione" colon={false}>
        {getFieldDecorator('description', {
          rules: [{ required: true, message: 'Inserisci una descrizione' }],
        })(<Input allowClear />)}
      </FormItemUppercase>
      <FormItemUppercase label="Data arrivo merce" colon={false}>
        {getFieldDecorator('merchArrivalDate', {
          initialValue: moment().add(31, 'days'),
          rules: [{ required: true, message: 'Inserisci una data' }],
        })(
          <DatePicker
            className="generic-datepicker"
            locale={DATE_LOCALE}
            format="DD/MM/YYYY"
            inputReadOnly
            allowClear={false}
            disabledDate={(currentDate) => {
              if (currentDate.isBefore(moment().add(31, 'day'), 'day')) {
                return true
              }

              const installation = form.getFieldValue('installation')
              if (installation && currentDate.isSameOrAfter(installation[0], 'day')) {
                return true
              }

              return false
            }}
          />,
        )}
      </FormItemUppercase>
      <FormItemUppercase label="Periodo promo" colon={false}>
        {getFieldDecorator('installation', {
          rules: [{ required: true, message: 'Inserisci un periodo' }],
        })(
          <RangePicker
            format="DD/MM/YYYY"
            placeholder={["Data d'inizio", 'Data di fine']}
            allowClear={false}
            disabledDate={(currentDate) => {
              const merchArrivalDate = form.getFieldValue('merchArrivalDate')
              if (merchArrivalDate && currentDate.isSameOrBefore(merchArrivalDate, 'day')) {
                return true
              }

              return false
            }}
          />,
        )}
      </FormItemUppercase>
      <FormItemCenter>
        <StyledButton type="primary" onClick={handleSubmit} loading={isSaving}>
          Salva
        </StyledButton>
      </FormItemCenter>
    </Form>
  )
})

const CreatePromoLocali = () => {
  const dispatch = useDispatch()
  const departments = useSelector((state) => state.Data.departments)
  const user = useSelector((state) => state.User)

  const [isLoading, setIsLoading] = useState(true)
  const [isSaving, setIsSaving] = useState(false)
  const [redirectTo, setRedirectTo] = useState(null)

  useEffect(() => {
    Promise.all([dispatch(fetchDepartments())]).then(() => setIsLoading(false))
  }, [dispatch])

  const handleSave = (values) => {
    const payload = {
      year: `${getYear(values.installation[0])}`,
      description: values.description.trim(),
      department: values.department,
      merchArrivalDate: formatDate(values.merchArrivalDate),
      installationFrom: formatDate(values.installation[0]),
      installationTo: formatDate(values.installation[1]),
      idStore: user.store,
      stato: 'DRAFT',
    }

    setIsSaving(true)
    api.promoLocali
      .create(payload)
      .then((response) => setRedirectTo(`/edit-promo-locali/${response.data.id}`))
      .catch(handleServerError)
      .finally(() => setIsSaving(false))
  }

  if (redirectTo) {
    return <Redirect to={redirectTo} />
  }

  if (isLoading) {
    return <Loader />
  }

  return (
    <MainLayout
      tourSteps={[]}
      isTourAvailable={false}
      isTourOpen={false}
      defaultCurrentPage="dossier"
    >
      <StyledH1>Crea Promo Locali</StyledH1>
      <Row type="flex" justify="center">
        <Col span={6}>
          <PromoLocaliForm
            departments={departments}
            onSave={handleSave}
            isSaving={isSaving}
          />
        </Col>
      </Row>
    </MainLayout>
  )
}

export default CreatePromoLocali
